import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Plan } from '@models/plan';
import { IResponseCollection } from '@core/shared/interfaces/response-collection.interface';

@Injectable({
  providedIn: 'root',
})
export class PlanApiService extends BaseApiService {
  private path = '/api/v1/plan';

  async getAll(params: any = {}): Promise<IResponseCollection<Plan>> {
    return this.get(`${this.path}`, params);
  }
}
